import React, { Component } from 'react';
import { connect } from 'react-redux';

import SummaryShareShort from '../../../components/purchase-dashboard/group-summary/summary-share.short';
import {
  showEditCommitModal,
  showWithdrawModal,
} from '../../../actions/index';
import {
  getCurrentUserMembership,
  getCurrentPurchase,
} from '../../../selectors/purchase-selector';
import Purchase from '../../../lib/purchase';

class SummaryShareShortContainer extends Component {
  constructor(props) {
    super(props);
    this.onCommit = this.onCommit.bind(this);
    this.onWithdraw = this.onWithdraw.bind(this);
  }

  onCommit() {
    this.props.showEditCommitModal();
  }

  onWithdraw() {
    this.props.showWithdrawModal();
  }

  render() {
    return (
      <SummaryShareShort
        membership={this.props.membership}

        disabled={this.props.disabled}

        onCommit={this.onCommit}
        onWithdraw={this.onWithdraw}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);
  const membership = getCurrentUserMembership(state);

  const disabled = !Purchase.isActive(purchase.status);

  return {
    membership,
    disabled,
    splitType: purchase.group.splitType,
    currentProductCostAmount: purchase.currentProductCostAmount,
  };
};

const mapDispatchToProps = {
  showEditCommitModal,
  showWithdrawModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryShareShortContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/group-summary/summary-share-short.container.js